import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LoopBackAuth } from '@careapp/angular-sdk';
import { DeveloperFunction } from '@devmod/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { production } from '../../environments/environment';
import * as actions from '../store/actions/auth.actions';
import * as selectors from '../store/reducers';

@Component({
  selector: 'sd-login',
  templateUrl: 'login.component.html',
  styleUrls: ['login.component.scss']
})
export class LoginComponent implements OnInit {
  jwt: string;
  organisationId: string;

  error: Observable<string>;
  loading: Observable<boolean>;

  attempts = 0;
  constructor(private auth: LoopBackAuth, private route: ActivatedRoute, public store: Store<any>) {
    this.error = this.store.select(selectors.auth.getError);
    this.loading = this.store.select(selectors.auth.getLoading);
  }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.jwt = params.jwt;
      this.organisationId = params.organisationId;
    });
  }

  @DeveloperFunction(
    production
      ? []
      : [
          {
            label: 'Login as Coordinator',
            args: [
              {
                email: 'COORDINATOR@example.com',
                password: 'development'
              }
            ]
          },
          {
            label: 'Login as Org Admin',
            args: [
              {
                email: 'ORG_ADMIN@example.com',
                password: 'development'
              }
            ]
          },
          {
            label: 'Login as Super Admin',
            args: [
              {
                email: 'aaaaaaaa-0000-0000-0000-000000000000@example.com',
                password: 'development'
              }
            ]
          }
        ]
  )
  login(payload: any) {
    this.store.dispatch(new actions.RequestAuthLoginAction(payload));
  }
}
